const referrerExists = () => {
  return traffic => {
    return traffic.referrer !== ''
  }
}

export default referrerExists



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/referrerExists.js